import React from 'react';
import { Calendar, CalendarPlus, Mail, Users, BookOpen, Heart, Clock, Settings } from 'lucide-react';

const AdminTabs = ({ activeTab, onTabChange, stats }) => {
  const tabs = [
    { id: 'overview', label: 'Overview', icon: <Calendar className="w-4 h-4" /> },
    { id: 'events', label: 'Events', icon: <CalendarPlus className="w-4 h-4" />, count: stats?.events, color: 'purple' },
    { id: 'contacts', label: 'Messages', icon: <Mail className="w-4 h-4" />, count: stats?.contacts?.unread },
    { id: 'volunteer-db', label: 'Volunteers', icon: <Users className="w-4 h-4" />, count: stats?.volunteer_database?.active, color: 'green' },
    { id: 'madrassah', label: 'Madrassah', icon: <BookOpen className="w-4 h-4" />, count: stats?.madrassah_students?.active, color: 'blue' },
    { id: 'donations', label: 'Donations', icon: <Heart className="w-4 h-4" />, count: stats?.donations?.pending },
    { id: 'prayer', label: 'Prayer Times', icon: <Clock className="w-4 h-4" /> },
    { id: 'settings', label: 'Settings', icon: <Settings className="w-4 h-4" /> },
  ];

  return (
    <div className="bg-white border-b shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex gap-1 overflow-x-auto">
          {tabs.map(tab => (
            <button 
              key={tab.id} 
              onClick={() => onTabChange(tab.id)} 
              className={`flex items-center gap-2 px-4 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeTab === tab.id 
                  ? 'border-[#c5a572] text-[#c5a572]' 
                  : 'border-transparent text-[#5a6d62] hover:text-[#1a2f23]'
              }`}
            >
              {tab.icon}{tab.label}
              {tab.count > 0 && (
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  tab.color === 'green' ? 'bg-green-100 text-green-800' : 
                  tab.color === 'blue' ? 'bg-blue-100 text-blue-800' : 
                  tab.color === 'purple' ? 'bg-purple-100 text-purple-800' : 
                  'bg-[#c5a572] text-white'
                }`}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminTabs;
